import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

const getActionsCss = css`
  padding: var(--cds-spacing-150) var(--cds-spacing-200) 0;

  ${breakpoints.up('sm')} {
    padding: var(--cds-spacing-150) var(--cds-spacing-200) 0;
  }

  ${breakpoints.up('md')} {
    padding: var(--cds-spacing-200) var(--cds-spacing-300) 0;
  }
`;

export default getActionsCss;
